import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import { CheckIcon } from './CheckIcon';

interface IconProps {
  color?: string;
  width?: number;
  height?: number;
  strokeWidth?: number;
}

interface ListItem {
  iconProps?: IconProps;
  text: string;
}

interface ContentTextBoxAndIconsProps {
  titleLine1: string;
  titleLine2: string;
  backgroundColor?: string;
  titleColor?: string;
  textColor?: string;
  listItems: ListItem[];
}

export const ContentTextBoxAndIcons: React.FC<ContentTextBoxAndIconsProps> = ({
  titleLine1,
  titleLine2,
  backgroundColor = '#ffffff',
  titleColor = '#000000',
  textColor = '#000000',
  listItems,
}) => {
  return (
    <m.div
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      style={{ backgroundColor }}
      className="w-full h-full xl:pl-44 flex flex-col justify-center items-start gap-4 md:gap-4 p-8 md:py-16"
    >
      <div className="text-start">
        <m.h2
          variants={itemVariants}
          style={{ color: titleColor }}
          className="mt-2"
        >
          <span className="text-2xl  block">{titleLine1}</span>
          <span className="text-5xl leading-[72px] block">{titleLine2}</span>
        </m.h2>
      </div>

      <m.ul
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className="list-none flex flex-col gap-6 "
      >
        {listItems.map((item, index) => (
          <m.li
            key={index}
            variants={itemVariants}
            className="flex items-center gap-3"
          >
            {item.iconProps && (
              <div className="flex-shrink-0">
                <CheckIcon {...item.iconProps} />
              </div>
            )}

            <p
              style={{ color: textColor }}
              className="text-xl md:text-2xl font-normal leading-[24px]  "
            >
              {item.text}
            </p>
          </m.li>
        ))}
      </m.ul>
    </m.div>
  );
};
